/**
 * @generated SignedSource<<b92da4a906361f661787638a2d9440c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoBottomSheetMainHeaderRight_todo$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"useTodoEditMoreMenuItems_todo">;
  readonly " $fragmentType": "TodoBottomSheetMainHeaderRight_todo";
};
export type TodoBottomSheetMainHeaderRight_todo$key = {
  readonly " $data"?: TodoBottomSheetMainHeaderRight_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoBottomSheetMainHeaderRight_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoBottomSheetMainHeaderRight_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useTodoEditMoreMenuItems_todo"
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "23a0212b699d5381b9c7f99675cc05f7";

export default node;
